import {
  keepPreviousData,
  useMutation,
  useQuery,
  useQueryClient,
} from "@tanstack/react-query";
import { HostersService } from "../services/hosters.service";
import { UpdateProAccountDto } from "../dto/index.dto";
import { DEFAULT_LIMIT } from "../../../shared/dto/pagination.dto";

export const useGetHosters = (
  event: string,
  page: number,
  limit: number = DEFAULT_LIMIT
) => {
  return useQuery({
    queryKey: ["hosters", event, page, limit],
    queryFn: () => {
      return HostersService.getHosters(event, page, limit);
    },
    placeholderData: keepPreviousData,
  });
};

export const useGetHosterById = (id: string, event: string) => {
  return useQuery({
    queryKey: ["hosters", "detail", id, event],
    queryFn: () => HostersService.getHosterById(id, event),
    enabled: !!id && !!event,
  });
};

export const useUpdateHosterHook = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({
      id,
      event,
      data,
    }: {
      id: string;
      event: string;
      data: UpdateProAccountDto;
    }) => HostersService.updateHoster(id, event, data),
    onSuccess: (updated, { id, event }) => {
      queryClient.setQueryData(["hosters", "detail", id, event], updated);
      queryClient.invalidateQueries({ queryKey: ["hosters", event] });
    },
  });
};

export const useSuspendHosterHook = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, event }: { id: string; event: string }) =>
      HostersService.suspendHoster(id, event),
    onSuccess: (updated, { id, event }) => {
      queryClient.setQueryData(["hosters", "detail", id, event], updated);
      queryClient.invalidateQueries({ queryKey: ["hosters", event] });
    },
  });
};

export const useReactivateHosterHook = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, event }: { id: string; event: string }) =>
      HostersService.reactivateHoster(id, event),
    onSuccess: (updated, { id, event }) => {
      queryClient.setQueryData(["hosters", "detail", id, event], updated);
      queryClient.invalidateQueries({ queryKey: ["hosters", event] });
    },
  });
};
